import { natureLists } from "@core/slice/ComplaintSlice.ts";
import { useAppSelector } from "@core/store/hook.ts";
import {
  ComplaintById,
} from "@modules/plaintes/plaintes.model.ts";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import React from "react";
interface ComplaintTypeProps {
  complaint: ComplaintById;
}
const ComplaintType: React.FC<ComplaintTypeProps> = ({ complaint }) => {
  const listsNature = useAppSelector(natureLists);
  const selectedComplaintType = complaint.subNatures.map((i) => i.id);

  return (
    <div className="rounded-[10px] p-4 bg-white flex flex-col">
      <span className="text-black text-sm font-semibold mb-2">
        Type de la plainte :
      </span>
      <div className="w-full flex items-baseline">
        <Accordion multiple className="mb-4">
          {listsNature?.map((nature) => (
            <AccordionTab
              key={nature.id}
              header={
                <span className="text-sm font-semibold">{nature.name}</span>
              }
            >
              <div className="p-2 space-y-2">
                {nature.subNatures.map((item) => (
                  <div key={item.id} className="flex items-center">
                    <Checkbox
                      inputId={`${item.id}`}
                      checked={selectedComplaintType.includes(item.id)}
                      disabled
                    />
                    <label htmlFor={`${item.id}`} className="ml-2 text-sm">
                      {item.description}
                    </label>
                  </div>
                ))}
              </div>
            </AccordionTab>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default ComplaintType;
